(() => {
    const subscribe = document.querySelector('.subscribe-modal')
    const close = document.querySelector('.close-modal')
    const form = document.getElementById('Form_SignupFormModal')

    if(subscribe) {

        function showModal() {
            subscribe.classList.add('active');
        }

        function closeModal() {
            localStorage.setItem('subscribed' , '1')
            subscribe.classList.remove('active');
        }

        close.addEventListener('click', closeModal)

        if (localStorage.getItem('subscribed') !== '1') {
            setTimeout(() => {
                showModal()
            }, 20000)
        }

        // Ajax submit
        function submitForm(e) {
            e.preventDefault();

            let status = document.getElementById('form-status');

            let data = this;

            fetch(data.getAttribute('action'), {
                method: 'POST',
                body: new FormData(data),
                headers: {
                    "Accept": "application/json; charset=utf-8",
                    "x-requested-with": "XMLHttpRequest"
                },
            })
                .then(res => res.json())
                .then(res => {
                    if(res.success) {
                        //status.innerHTML = "Thanks for your submission!";
                        closeModal()
                    } else {
                        status.innerHTML = "There was an error submitting this form, please try again";
                    }
                });

        }

        form.addEventListener('submit', submitForm);

    }
})()
